import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import '../../App.css';
import { IApplicationState } from '../../Store';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { IPlayerState } from '../../Store/Player/Types';
import { ISearchState } from '../../Store/Search/Types';
import { IUserState } from '../../Store/User/Types';
import { TableDetails } from '../TableDetails';
import { showDrawer } from '../../Store/Layout/Actions';
import { RouteComponentProps } from 'react-router-dom';
import { Export } from '../Dashboard/Export';
import { isNullOrUndefined } from '../../Utils/Various';
import { getExportPlayerPdf, getExportPlayerXls } from '../../Store/Export/Actions';

const styles = (theme:any) => MD.createStyles({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    clear:'both',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden:{
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
  },
  toggleDiv:{
    width:'100%',
  }
});

interface IPropsFromState {
  i18n: I18N;
  localeInfos: ILocaleInfos;
  player: IPlayerState;
  search : ISearchState;
  user: IUserState;
  router: RouteComponentProps<{}>;
}

interface IPropsFromDispatch {
  showDrawer: typeof showDrawer
  getExportPlayerPdf: typeof getExportPlayerPdf
  getExportPlayerXls: typeof getExportPlayerXls
}

interface IState {

}

type AllProps =
    MD.WithTheme &
MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch;

export class PlayerContentComponent extends React.Component<AllProps, IState> {

    public constructor(props: AllProps) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
      this.props.showDrawer();
    }

    private buildTableInfos() {
      const { i18n, player } = this.props;
      return (
        !isNullOrUndefined(player.broadcasts) && player.broadcasts.length > 0 && 
        <div id="table-infos" style={{paddingBottom: '20px'}}>
            <MD.Typography>
              {player.tableLabel}
            </MD.Typography>
            <div>
              {
                player.summary !== undefined && 
                <>
                  <span>
                    <span style={{ color: this.props.theme.palette.primary.main}}>
                      {player.summary[0].count}
                    </span> &nbsp;interventions&nbsp;
                    <span style={{ color: this.props.theme.palette.primary.main}}>
                      {player.summary[0].duration_hms}
                    </span>
                  </span>
                  <br></br>
                  <span>
                    {("0" + (player.startDate.getDate())).slice(-2)}
                    -{("0" + (player.startDate.getMonth()+1)).slice(-2)}
                    -{player.startDate.getFullYear().toString().substring(2,4)} 
                    &nbsp;00:00:00&nbsp;
                    {i18n._('at')} &nbsp;
                    {("0" + (player.endDate.getDate())).slice(-2)}
                    -{("0" + (player.endDate.getMonth()+1)).slice(-2)}
                    -{player.endDate.getFullYear().toString().substring(2,4)}
                    &nbsp;00:00:00&nbsp;
                  </span>
                </>
              }
            </div>
        </div>
      )
    }

    private buildExport() {
      const { player } = this.props;
      let filters:any = {}
      if (player.currentSearch === 'rapid' && player.playerRapidSearchFilters !== null) {
        filters = {  
          study_type_id: player.playerRapidSearchFilters.study_type_id,
          media_ids: player.playerRapidSearchFilters.media_ids,
          program_type_ids: player.playerRapidSearchFilters.program_type_ids,
          program_editor_ids: player.playerRapidSearchFilters.program_editor_ids,
          start_date: player.playerRapidSearchFilters.start_date,
          end_date: player.playerRapidSearchFilters.end_date,
          person_name: player.playerRapidSearchFilters.person_name
        }
      }
      else if (player.currentSearch === 'emission' && player.emissionSearchFilters !== null) {
        filters = {
          study_type_id: player.emissionSearchFilters.study_type_id,
          media_ids: player.emissionSearchFilters.media_ids,
          program_type_ids: player.emissionSearchFilters.program_type_ids,
          program_editor_ids: player.emissionSearchFilters.program_editor_ids,
          start_date: player.emissionSearchFilters.date_start,
          end_date: player.emissionSearchFilters.date_end,
          emission_name: player.emissionSearchFilters.emission_name
        }
      } 
      else if (player.currentSearch === 'advanced' && player.advancedSearchPlayerFilters !== null) {
        filters = {  
          study_type_id: player.advancedSearchPlayerFilters.study_type_id,
          media_ids: player.advancedSearchPlayerFilters.media_ids,
          program_type_ids: player.advancedSearchPlayerFilters.program_type_ids,
          program_editor_ids: player.advancedSearchPlayerFilters.program_editor_ids,
          start_date: player.advancedSearchPlayerFilters.start_date,
          end_date: player.advancedSearchPlayerFilters.end_date,
          person_id: player.advancedSearchPlayerFilters.person_id,
          political_group_id: player.advancedSearchPlayerFilters.political_group_id,
          time_slot_start: player.advancedSearchPlayerFilters.time_slot_start,
          time_slot_end: player.advancedSearchPlayerFilters.time_slot_end
        }
      }
      
      return (
        <div style={{position: 'absolute', right: '15px', display: 'inline-flex', paddingTop: 10}}>
            <Export exportAction={this.props.getExportPlayerPdf} 
            filters={filters} exportType = 'pdf' />
            <Export exportAction={this.props.getExportPlayerXls} 
            filters={filters} exportType = 'xls' />
        </div>
    )}

    public render(): React.ReactNode {
        const { i18n, player } = this.props;

        return (
          <React.Fragment>
            { player.isLoading && 
            <div>
              {i18n._('Loading')}..
            </div>
            }
            { ! player.isLoading && ((!isNullOrUndefined(player.broadcasts) && player.broadcasts.length === 0) || isNullOrUndefined(player.broadcasts)) && 
            <div>
              {i18n._('No results')}
            </div>
            }
            {
              this.buildTableInfos()
            }
            {
              !isNullOrUndefined(player.broadcasts) && player.broadcasts.length > 0 && player.currentSearch === 'rapid' &&
              this.buildExport()
            }
            {
              !isNullOrUndefined(player.broadcasts) && player.broadcasts.length > 0 &&
              <TableDetails
                data={player.broadcasts}
                type={'player'}
                hideMediaFilter={true}
              />
            }
          </React.Fragment>
        )
    }
}


const mapStateToProps = ({i18n, player, search, user} : IApplicationState, ownProps: RouteComponentProps<{}>) => {
  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    player,
    search,
    user,
    router: ownProps
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  showDrawer: () => dispatch(showDrawer()),
  getExportPlayerPdf: (filters: any) => dispatch(getExportPlayerPdf(filters)),
  getExportPlayerXls: (filters: any) => dispatch(getExportPlayerXls(filters)),

});

export const PlayerContent = 
    connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(PlayerContentComponent)));
